import PostTemplate from '@linc-technologies/linced-common/models/posts/post-template';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';

// Proto: posts.PostTemplateTemplate.
export default class _PostTemplate extends PostTemplate {
  declare [Type]: 'posts/post-template';

  // jurisdictions is a list of Jurisdictions which this template applies to.
  @array('number')
  declare jurisdictions: StatefulArray<number>;
}
